import OrderConfirmationContent from 'components/order-confirmation/OrderConfirmationContent';
import MainLayout from 'components/layout/MainLayout';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';

const OrderConfirmation2026 = observer(() => {
  const {
    currentUser,
    activeSubscriptions,
    activeWeeklyDrawTickets,
    isInMonthlyRaffle,
  } = useUserStore();

  if (
    !currentUser ||
    !activeSubscriptions ||
    !activeWeeklyDrawTickets ||
    !activeWeeklyDrawTickets.length ||
    activeSubscriptions.length === 0
  ) {
    return null;
  }

  return (
    <MainLayout limitItemWidths noHeaderDropShadow>
      <OrderConfirmationContent
        currentEmailAddress={currentUser.emailAddress}
        activeSubscription={activeSubscriptions[0]}
        activeWeeklyDrawTickets={activeWeeklyDrawTickets}
        isInMonthlyRaffle={isInMonthlyRaffle}
      />
    </MainLayout>
  );
});

export default OrderConfirmation2026;
